<template>
  <div>
    <VipHeaderCompose />
    <div id="body">
      <div class="compose show-model">
        <ComposeLeft index="5"></ComposeLeft>
        <div class="compose_main">
          <div class="wrapper">
            <div
              class="i-box"
              v-infinite-scroll="nextPage"
              infinite-scroll-disabled="disabled"
            >
              <div class="i-box_title">
                <h4>报告</h4>
              </div>
              <div class="i-box_content">
                <div class="report-list">
                  <el-skeleton
                    :loading="loading"
                    :count="skeletonCount"
                    animated
                  >
                    <template slot="template">
                      <div class="list-item">
                        <div class="pic">
                          <el-skeleton-item variant="image" />
                        </div>
                        <div class="title">
                          <el-skeleton-item variant="h2" />
                        </div>
                        <div class="time">
                          <el-skeleton-item variant="text" />
                        </div>
                      </div>
                    </template>
                    <template>
                      <div
                        class="list-item"
                        v-for="(item, index) in pageData"
                        :key="index"
                      >
                        <!-- <div class="sel">
                          <el-checkbox label=""></el-checkbox>
                        </div> -->
                        <div class="pic">
                          <a
                            :href="'/console/editor?id=' + item.id"
                            target="_blank"
                          >
                            <el-image
                              :src="require('@/assets/images/sample-pic7.png')"
                            ></el-image>
                          </a>
                        </div>
                        <div class="type">
                          <i class="icon-type-w"></i>
                        </div>
                        <div class="title">{{ item.title }}</div>
                        <div class="time">
                          {{
                            dateFormat(item.createTime, "YYYY-MM-DD HH:mm:ss")
                          }}
                        </div>
                        <div class="op">
                          <el-button size="small" circle
                            ><img src="~@/assets/images/icon-menu.png"
                          /></el-button>
                          <div class="op-dropdown-menu">
                            <ul>
                              <!-- <li>
                                <img
                                  src="~@/assets/images/icon-dropdown-i1.png"
                                  alt=""
                                />预览
                              </li>
                              <li>
                                <img
                                  src="~@/assets/images/icon-dropdown-i2.png"
                                  alt=""
                                />克隆
                              </li>
                              <li>
                                <img
                                  src="~@/assets/images/icon-dropdown-i3.png"
                                  alt=""
                                />分享
                              </li> -->

                              <li
                                @click="
                                  handleFolderTreeDialog(
                                    1,
                                    item.folderId,
                                    item.id
                                  )
                                "
                              >
                                <img
                                  src="~@/assets/images/icon-dropdown-i4.png"
                                  alt=""
                                />复制到
                              </li>
                              <li
                                @click="
                                  handleFolderTreeDialog(
                                    0,
                                    item.folderId,
                                    item.id
                                  )
                                "
                              >
                                <img
                                  src="~@/assets/images/icon-dropdown-i5.png"
                                  alt=""
                                />移动到
                              </li>
                              <li @click="handleDelUserReport(item.id)">
                                <img
                                  src="~@/assets/images/icon-dropdown-i6.png"
                                  alt=""
                                />删除
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                </div>
                <div v-if="!loading && (!pageData || pageData.length === 0)">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FolderTreeDialog
      ref="folderTreeDialog"
      :folderTreeDialogType="folderTreeDialogType"
      :folderTreeDialogTitle="folderTreeDialogTitle"
      :currentNodeKey="currentNodeKey"
      :defaultExpandedKeys="defaultExpandedKeys"
      :folderTreeDialogId="folderTreeDialogId"
      @refreshData="resetPagedList"
    ></FolderTreeDialog>
  </div>
</template>

<script>
import VipHeaderCompose from "@/components/headerCompose.vue";
import ComposeLeft from "@/components/compose/left.vue";
import ComposeSearch from "@/components/compose/search.vue";
import FolderTreeDialog from "@/components/compose/folderTreeDialog.vue";
import { axiosOptions, axiosRequest } from "../../util/request";
import { delUserReport } from "../../util/utils";
import moment from "moment";

export default {
  components: {
    VipHeaderCompose,
    ComposeLeft,
    ComposeSearch,
    FolderTreeDialog,
  },
  data() {
    return {
      loading: false,
      type: 2,
      listType: 0,
      pageIndex: 1,
      pageSize: 12,
      pageData: [],
      total: 0,
      pageCount: 0,
      composeLeftIndex: "5",
      skeletonCount: 12,

      folderTreeDialogType: 0,
      folderTreeDialogTitle: "移动到",
      defaultExpandedKeys: [0],
      currentNodeKey: 0,
      folderTreeDialogId: 0,
    };
  },
  created() {
    this.getPagedList();
  },
  computed: {
    disabled() {
      return this.loading;
    },
  },
  methods: {
    resetPagedList() {
      this.pageIndex = 1;
      this.pageData = [];
      this.getPagedList();
    },
    handleDelUserReport(id) {
      delUserReport(id, 1)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            let removeIndex = this.pageData.findIndex((a) => a.id === id);
            if (removeIndex > -1) {
              this.pageData.splice(removeIndex, 1);
            }
          }
        })
        .catch(() => {});
    },
    handleFolderTreeDialog(type, folderId, id) {
      switch (type) {
        case 0:
          this.folderTreeDialogTitle = "移动到";
          break;
        case 1:
          this.folderTreeDialogTitle = "复制到";
          break;
      }
      this.folderTreeDialogType = type;
      this.defaultExpandedKeys = [folderId];
      this.currentNodeKey = folderId;
      this.folderTreeDialogId = id;
      this.$refs.folderTreeDialog.show();
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },
    nextPage() {
      if (this.pageIndex + 1 <= this.pageCount) {
        this.pageIndex++;
        this.getPagedList();
      }
    },
    getPagedList() {
      this.loading = true;
      axiosRequest(
        "/user-report/paged-list",
        {
          type: this.type - 1,
          listType: this.listType,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.loading = false;
          if (res.data && res.data.code === 200) {
            res.data.data.records.forEach((element) => {
              this.pageData.push(element);
            });
            //console.log(this.pageData);
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;

            this.skeletonCount = this.pageIndex * this.pageSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/compose.scss";

.console ::v-deep .console_main {
  .write-model {
    margin-right: 0 !important;

    .catalog_content {
      line-height: 1.3;
    }

    .console-content {
      padding-left: 10px !important;
      padding-right: 10px !important;

      .w-e-bar-item {
        padding: 0;
      }

      .f-top {
        .label {
          margin-left: 0;
        }
      }
    }

    .el-range-separator {
      width: 20px;
    }
    .data-show {
      max-width: 394px;
      background-color: #fff;
      @include scroll;
    }

    #header-container {
      li {
        width: 210px;
      }
      li[type="header1"] {
        font-size: 18px;
      }
      li[type="header2"] {
        font-size: 16px;
      }
      li[type="header3"] {
        font-size: 14px;
      }
    }

    .w-e-text-container {
      line-height: 1.5;
      font-family: 宋体;

      h1 {
        font-size: 22px;
      }
      h2 {
        font-size: 19px;
      }
      h3 {
        font-size: 16px;
      }

      ol {
        list-style-type: decimal;
      }
      ul {
        list-style-type: disc;
      }
    }

    .resource-tabs {
      height: 100%;

      .el-tabs__content {
        height: calc(100% - 52px);
        overflow: hidden;

        .el-tab-pane {
          height: 100%;

          .op {
            padding: 20px 0;
            .el-input {
              width: calc(100% - 66px) !important;
              margin-right: 10px !important;
            }
            .el-button {
              width: 56px;
            }
          }

          .article-list {
            height: calc(100% - 80px);
            overflow: auto;

            dt,
            dd {
              white-space: unset;
              overflow: unset;
            }
            dd.op {
              text-align: right;
            }
            .pic {
              text-align: center;

              .el-image {
                img {
                  width: 340px;
                  height: auto;
                  cursor: pointer;

                  // width: auto;
                  // height: 190px;

                  //height: 220px;
                }
              }
            }

            /* table 样式 */
            table {
              border-top: 1px solid #ccc;
              border-left: 1px solid #ccc;
            }
            table td,
            table th {
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
              padding: 3px 5px;
            }
            table th {
              border-bottom: 2px solid #ccc;
              text-align: center;
            }

            /* blockquote 样式 */
            blockquote {
              display: block;
              border-left: 8px solid #d0e5f2;
              padding: 5px 10px;
              margin: 10px 0;
              line-height: 1.4;
              font-size: 100%;
              background-color: #f1f1f1;
            }

            /* code 样式 */
            code {
              display: inline-block;
              *display: inline;
              *zoom: 1;
              background-color: #f1f1f1;
              border-radius: 3px;
              padding: 3px 5px;
              margin: 0 3px;
            }
            pre code {
              display: block;
            }

            /* ul ol 样式 */
            ul,
            ol {
              margin: 10px 0 10px 20px;
            }
          }
        }
      }
    }
  }
}
</style>
